<!--
  登陆
  jay  2019-05-27
-->
<template>
  <div class="login">
    <div class="logo" @click="toIndex">
      <img src="@/assets/images/public/logo_1.png" />
      <h1>{{ $t("common.eepay") }}</h1>
    </div>
    <div class="login-main">
      <div class="login-form">
        <h2 class="text-blue">{{ $t("common.loginName") }}</h2>
        <Form :model="formCode" v-if="codeLog">
          <FormItem prop="phone">
            <Input
              prefix="ios-phone-portrait"
              type="text"
              v-model="phone"
              :placeholder="$t('common.enterMobile')"
            />
          </FormItem>
          <FormItem prop="code" class="item-code">
            <Input
              prefix="ios-lock-outline"
              type="text"
              v-model="code"
              class="codeInput"
              :placeholder="$t('common.enterVerificationCode')"
            />
            <span class="codeBtn" @click="sendMobile">{{ showMsg }}</span>
          </FormItem>
        </Form>
        <Form :model="formPsd" v-else>
          <FormItem prop="phone">
            <Input
              prefix="ios-phone-portrait"
              type="text"
              v-model="userName"
              :placeholder="$t('common.AccountPlaceholder')"
            />
          </FormItem>
          <FormItem prop="password" class="item-password">
            <Input
              prefix="ios-lock-outline"
              type="password"
              v-model="passWord"
              password
              :placeholder="$t('common.PasswordFormat')"
              @keyup.enter.native="pswLogin"
            />
          </FormItem>
        </Form>
        <Button type="primary" @click="login">
          {{ $t("common.login") }}
        </Button>
        <div class="bottom">
          <a href="javascript:void(0);" class="text-blue" @click="logWay">
            {{
              codeLog
                ? $t("common.accountLogin")
                : $t("common.verificationCodeLogin")
            }}
          </a>
          <a
            href="javascript:void(0);"
            class="text-blue"
            @click="popFlag = true"
          >
            {{ $t("common.noAccountYet") }}
          </a>
        </div>
      </div>
    </div>

    <div class="download-app" v-if="popFlag">
      <div class="pop-mask" @click="popFlag = false"></div>
      <div class="pop-content">
        <div class="qrcode-down">
          <div class="del-btn" @click="popFlag = false"></div>
          <div class="qrcode-item">
            <div class="down-box">
              <div class="pop-title">iOS</div>
              <div class="qrcode">
                <img
                  alt="菲律宾生活缴费eepay"
                  :src="httpUrl + '/qrcode/app_ios_download_qrcode.png'"
                />
              </div>
            </div>
            <div class="down-box">
              <div class="pop-title">Android</div>
              <div class="qrcode">
                <img
                  alt="菲律宾生活缴费eepay"
                  :src="httpUrl + '/qrcode/app_android_download_qrcode.png'"
                />
              </div>
            </div>
          </div>

          <div class="pop-txt">{{ $t("common.scanCodeDownload") }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "login",
  meta: {
    head: false,
    power: false
  },
  components: {},
  data() {
    return {
      formPsd: {},
      formCode: {},
      phone: "", //手机号
      code: "", //验证码
      showMsg: this.$t("common.getItNow"),
      showTime: 60,
      userName: "",
      passWord: "",
      codeLog: false,
      popFlag: false
    };
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    toIndex() {
      this.$router.push({
        path: "/"
      });
      // window.location.href = window.location.origin;
    },
    logWay() {
      // 切换账号、手机登录
      this.codeLog = !this.codeLog;
      this.countDownFlag = false;
      this.againFlag = false;
    },
    login() {
      // 登录
      if (this.codeLog) {
        this.codeLogin();
      } else {
        this.pswLogin();
      }
    },
    pswLogin() {
      //账号登陆
      let vm = this;
      if (vm.userName == "") {
        vm.$Message.error(vm.$t("common.enterAccount"));
        return false;
      }
      if (vm.passWord == "") {
        vm.$Message.error(vm.$t("common.enterPassword"));
        return false;
      }
      let params = {};
      params.username = vm.userName;
      params.password = vm.passWord;
      this.$post("/app/user/login", params, { loading: true }).then(res => {
        localStorage.setItem("token", res.token);
        vm.$store.dispatch("SET_TOKEN", res.token);
        vm.$store.dispatch("GET_USER_INFO");
        vm.$router.push({
          path: "/"
        });
      });
    },
    sendMobile() {
      // 获取手机验证码
      let vm = this;
      if (vm.phone == "") {
        vm.$Message.error(vm.$t("verify.mobileNull"));
        return false;
      }
      let params = {};
      // 号码处理先删除空格转换成数字再补0
      params.phone = "0" + Number(vm.phone.replace(/\s/g, ""));
      params.type = 1;
      vm.$post("/app/captcha/sendMobile", params, {
        alert: true
      }).then(res => {
        console.log("sendMobile", res);
        if (res.code == 0) {
          vm.$Message.success(res.msg);
          vm.showMsg = vm.$t("common.remaining") + vm.showTime + "s";
          vm.setTimer();
        } else {
          vm.$Message.error(res.msg);
        }
      });
    },
    setTimer() {
      // 倒计时定时器
      let vm = this;
      clearTimeout(vm.timer);
      vm.timer = setTimeout(() => {
        if (vm.showTime == 0) {
          vm.showMsg = this.$t("common.getAgain");
          vm.showTime = 60;
          return false;
        }
        vm.showTime--;
        vm.showMsg = vm.$t("common.remaining") + vm.showTime + "s";
        vm.setTimer();
      }, 1000);
    },
    codeLogin() {
      //验证码登陆
      let vm = this;
      if (vm.phone == "") {
        vm.$Message.error(vm.$t("verify.mobileNull"));
        return false;
      }
      if (vm.code == "") {
        vm.$Message.error(vm.$t("verify.verificationCodeNull"));
        return false;
      }
      let params = {};
      params.phone = vm.phone;
      params.code = vm.code;
      this.$post("/app/user/loginByMobile", params, { loading: true }).then(
        res => {
          console.log("loginByMobile", res);
          localStorage.setItem("token", res.token);
          vm.$store.dispatch("SET_TOKEN", res.token);
          vm.$store.dispatch("GET_USER_INFO");
          vm.$router.push({
            path: "/"
          });
          clearTimeout(vm.timer);
        }
      );
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
@imgUrl: "~@/assets/images/";
.login {
  min-width: 1200px;
  width: 100%;
  height: 100%;
  background-size: cover;
  position: relative;
  .logo {
    position: absolute;
    top: 56px;
    left: 50px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    cursor: pointer;
    img {
      height: 39px;
      margin-right: 10px;
    }
    h1 {
      font-size: 28px;
      font-weight: 400;
      line-height: 1;
    }
  }
}

.login-main {
  width: 400px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  .login-img {
    width: 50%;
  }
  .login-form {
    width: 100%;
    padding: 50px 50px 30px;
    background: #fff;
    box-shadow: 0px 10px 14px 0px rgba(0, 3, 56, 0.23);
    border-radius: 6px;
    h2 {
      margin-bottom: 15px;
      font-size: 24px;
      font-weight: 400;
      line-height: 1.2;
    }
    .item-password {
      .ivu-input {
        padding: 0 40px;
      }
    }
    .item-code {
      /deep/.ivu-form-item-content {
        display: flex;
        .ivu-input-wrapper {
          flex: 1;
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
        }
        .codeBtn {
          position: relative;
          cursor: pointer;
          width: 90px;
          padding: 0 5px;
          text-align: center;
          border-top-right-radius: 8px;
          border-bottom-right-radius: 8px;
          background: #eff2f5;
          color: #2042ab;
          font-size: 12px;
          &:after {
            content: "";
            width: 1px;
            height: 50%;
            background: #2042ab;
            position: absolute;
            top: 25%;
            left: 0;
          }
        }
      }
    }
    /deep/.ivu-form-item-content {
      line-height: 48px;
      .ivu-input-wrapper {
        background: #eff2f5;
        border-radius: 8px;
        overflow: hidden;
        .ivu-input {
          height: 48px;
          font-size: 18px;
          border: 0;
          background: inherit;
          &:focus {
            box-shadow: inherit;
          }
        }
        .ivu-input-with-prefix {
          padding-left: 40px;
        }
        .ivu-input-suffix,
        .ivu-input-prefix {
          width: 40px;
          display: flex;
          justify-content: center;
          align-items: center;
          .ivu-icon {
            font-size: 22px;
            color: #2042ab;
          }
        }
      }
    }
    /deep/.ivu-btn {
      width: 100%;
      height: 48px;
      font-size: 18px;
      margin-top: 18px;
    }
  }
  .bottom {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    line-height: 1.2;
  }
}

.download-app {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  .pop-mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.65);
    z-index: -1;
  }
  .pop-content {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .qrcode-down {
      // width: 60%;
      // height: 50%;
      padding: 40px 100px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 6px 14px 0px rgba(0, 3, 56, 0.23);
      border-radius: 12px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: relative;
      .qrcode-item {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 20px;
        .down-box + .down-box {
          margin-left: 30px;
        }
      }
      .del-btn {
        width: 16px;
        height: 16px;
        position: absolute;
        top: 25px;
        right: 25px;
        background: red;
        cursor: pointer;
        background: url("@{imgUrl}public/close.png") no-repeat;
        background-size: cover;
      }
      .pop-title {
        font-size: 28px;
        color: #2042ab;
        line-height: 40px;
        text-align: center;
      }
      .qrcode {
        width: 180px;
        height: 180px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 24px 0;
        img {
          max-width: 100%;
          max-height: 100%;
        }
      }
      .pop-txt {
        font-size: 28px;
        color: #2042ab;
        line-height: 40px;
      }
    }
  }
}
</style>
